'use client';

import { useState } from "react";
import type { CatalogItem } from "@/lib/airtable";
import { useSwipeRecommender, type InitialPreferences } from "@/hooks/useSwipeRecommender";
import { SwipeDeck } from "./SwipeDeck";
import { SwipeOnboarding } from "./SwipeOnboarding";

type Props = {
  items: CatalogItem[];
};

export function SwipePageClient({ items }: Props) {
  const [showOnboarding, setShowOnboarding] = useState(true);
  const [preferences, setPreferences] = useState<InitialPreferences | undefined>(undefined);

  const handleOnboardingComplete = (prefs: InitialPreferences) => {
    setPreferences(prefs);
    setShowOnboarding(false);
  };

  const { currentItem, like, dislike, undo, canUndo, remainingCount, reset, likedItems, dislikedItems } = useSwipeRecommender(items, preferences);

  if (showOnboarding) {
    return <SwipeOnboarding onComplete={handleOnboardingComplete} />;
  }

  return (
    <div className="flex justify-center px-4 py-8 md:py-10">
      <div className="w-full max-w-md">
        <SwipeDeck
          item={currentItem}
          onLike={like}
          onDislike={dislike}
          onUndo={undo}
          canUndo={canUndo}
          onReset={reset}
          remainingCount={remainingCount}
          likedItems={likedItems}
          dislikedItems={dislikedItems}
        />
      </div>
    </div>
  );
}
